import React, { createContext, useContext, useRef } from "react"
import { create, useStore } from "zustand"
import { EpisodeOfCareFragment$key } from "@/modules/patients/detail/episode-of-care/types/episode-of-care-fragment-type"

interface EpisodeOfCareDialogStoreState {
  episodeOfCareRef: EpisodeOfCareFragment$key | null
  setEpisodeOfCareRef: (value: EpisodeOfCareFragment$key | null) => void
}

const createEditEpisodeOfCareDialogStore = () => {
  return create<EpisodeOfCareDialogStoreState>((set) => ({
    episodeOfCareRef: null,
    setEpisodeOfCareRef: (value) => set({ episodeOfCareRef: value }),
  }))
}

type EditEpisodeOfCareDialogStoreType = ReturnType<typeof createEditEpisodeOfCareDialogStore>

const EditEpisodeOfCareDialogStoreContext = createContext<EditEpisodeOfCareDialogStoreType | null>(null)

type EditEpisodeOfCareDialogStoreProviderProps = React.PropsWithChildren

export const EditEpisodeOfCareDialogStoreProvider = ({ children }: EditEpisodeOfCareDialogStoreProviderProps) => {
  const storeRef = useRef<EditEpisodeOfCareDialogStoreType>(undefined)
  if (!storeRef.current) {
    storeRef.current = createEditEpisodeOfCareDialogStore()
  }
  return (
    <EditEpisodeOfCareDialogStoreContext.Provider value={storeRef.current}>
      {children}
    </EditEpisodeOfCareDialogStoreContext.Provider>
  )
}

export function useEditEpisodeOfCareDialogStoreContext<T>(selector: (state: EpisodeOfCareDialogStoreState) => T): T {
  const store = useContext(EditEpisodeOfCareDialogStoreContext)
  if (!store) throw new Error("Missing EditEpisodeOfCareDialogStoreProvider in the tree")
  return useStore(store, selector)
}
